import {ChangeDetectionStrategy, Component, inject, input, InputSignal} from "@angular/core";
import {MenuModel} from "../menu.model";
import {IconButtonComponent} from "../../buttons/icon-button/icon-button.component";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {MenuCategoryData} from "../menu-entity.model";
import {ResponsiveDirective} from "../../responsive/responsive.directive";
import {NgClass} from '@angular/common';
import {ImageCacheDirective} from '../../ui-elements/image/image-cache.directive';
import {TouchableDirective} from '../../ui-elements/touchable.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-menu-category-selection-panel",
    templateUrl: "./menu-category-selection-panel.component.html",
    styleUrl: "./menu-category-selection-panel.component.scss",
    host: {
        "[class.with-images]": "menuModel.showCategoryImages()"
    },
    imports: [
        IconButtonComponent,
        ImageCacheDirective,
        NgClass,
        ResponsiveDirective,
        TouchableDirective,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuCategorySelectionPanelComponent {
    public menuModel: MenuModel = inject(MenuModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    IconButtonType = IconButtonType;

    public readonly showNavIcons: InputSignal<boolean> = input<boolean>(true);

    selectCategory(category: MenuCategoryData): void {
        this.menuModel.selectCategory(category);
    }
}
